export { default } from './info.jsx';
